import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.public-form').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  // Public Form route
  $stateProvider.state(STATE_MAPPINGS.publicForm, {
    url: '/form/{id}',
    params: {
      title: 'Public Form',
      formType: 'flowingly_public_form',
      isExternalForm: false
    },
    controller: 'runnerPublicFormController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.public-form/runner.public-form.tmpl.html'
  });

  // Flow Step route
  $stateProvider.state('app.external-actor-step', {
    url: '/flow/{flowIdentifier}/step/{stepId}',
    params: {
      title: 'External Actor Step',
      formType: 'flowingly_external_actor_step',
      isExternalForm: true
    },
    controller: 'runnerPublicFormController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.public-form/runner.public-form.tmpl.html'
  });
}
